import dragula from "dragula";
import renumberStatements from "../renumber-statements";

export default function (context) {
    const $context = $(context);
    const statementListPart = $context.find('.statements-list-part').get(0);
    const warmupListPart = $context.find('.warmups-list-part').get(0);
    const acceptedTargetContainers = [statementListPart, warmupListPart];
    const recommendedStatementListContainer = $context.find('.recommended-statements-list-container').get(0);
    const companyStatementListContainer = $context.find('.company-statements-list-container').get(0);
    const acceptedSourceContainers = [recommendedStatementListContainer, companyStatementListContainer];

    const drake = dragula([
        statementListPart,
        warmupListPart,
        recommendedStatementListContainer,
        companyStatementListContainer,
    ], {
        revertOnSpill: true, // The item returns to the list if is not dropped in accepted container
        copy: function (el, source) {
            // Do not remove element from recommended/company statements container
            return acceptedSourceContainers.includes(source);
        },
        moves: function (el, source, handle, sibling) {
            return handle.classList.contains('statement-drag-handler');
        },
        accepts: function (el, target, source) {
            // Block drag`n drop between target containers
            if (acceptedTargetContainers.includes(source)) {
                return target === source;
            }

            // Accept drag`n drop only from recommended/company statements to target container
            return acceptedTargetContainers.includes(target);
        },
    });

    drake.on('drop', function (el, target, source) {
        if (target === source) {
            // stop drop event, it's only sorting so renumber list
            renumberStatements(target);
            return;
        }

        if (target.hasAttribute('data-statements-list')) {
            $context.trigger('copy-statement', [el]);
        }

        if (target.hasAttribute('data-warmups-list')) {
            $context.trigger('copy-warmup', [el]);
        }
    });
}
